import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'sc-mat-table-filter',
  templateUrl: './mat-table-filter.fragment.html',
  styleUrls: ['./mat-table-filter.fragment.scss']
})
export class MatTableFilterFragment implements OnInit {

  @Output() public filterEvent = new EventEmitter();
  @Input() public filterValue: string;
  @Input() public filters: string[];

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor() {}

  public ngOnInit(): void {
  }

  public onFilter(event) {
    this.filterEvent.emit(event);
  }

  public addFilter(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.filters.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.filterEvent.emit(this.filters);
  }

  public removeFilter(filter: string): void {
    const index = this.filters.indexOf(filter);
    if (index >= 0) {
      this.filters.splice(index, 1);
    }
    this.filterEvent.emit(this.filters);
  }
}
